import React from "react";
import { useNavigate } from "react-router-dom";
import { facials, massages, packages } from "../../data/services";
import "./Services.css";

const Services = () => {
  const navigate = useNavigate();

  const handleBookService = (serviceName, serviceType) => {
    navigate("/bookings", {
      state: {
        preselectedService: serviceName,
        serviceType: serviceType,
      },
    });
  };

  const deluxePackage = packages[0];

  const facialPerks = [
    "10-minute face & shoulder massage",
    "Herbal steam towel ritual",
    "10 minutes of LED light therapy",
    "Pre-treatment coffee, cappuccino, or herbal tea",
    "Optional aromatherapy",
  ];

  const massagePerks = [
    "10-minute deep stretch before bodywork",
    "Herbal steam towel ritual",
    "Hot stones",
    "Pre-treatment coffee, cappuccino, or herbal tea",
  ];

  return (
    <div className="services-page">
      <section className="services-hero">
        <div className="hero-content">
          <span className="hero-subtitle">
            Experience Transformative Wellness
          </span>
          <h1>Our Services</h1>
          <div className="hero-divider"></div>
          <p>
            Indulge in bespoke treatments that rejuvenate your body, restore
            your spirit, and reveal your natural radiance
          </p>
        </div>
      </section>

      <section className="services-section facials-section">
        <div className="section-content">
          <div className="services-header">
            <span className="section-label">Signature Treatments</span>
            <h2>Customized Luxe Facials</h2>
            <p className="duration-note">60 or 90 minutes</p>
          </div>

          <div className="services-list">
            {facials.map((facial, index) => (
              <div
                key={index}
                className={`service-item ${
                  facial.features ? "featured-service" : ""
                }`}
              >
                <div className="service-top">
                  <div className="service-title-row">
                    <h3>{facial.name}</h3>
                    <span className="service-price">{facial.price}</span>
                  </div>
                  <p className="service-description">{facial.description}</p>
                </div>
                {facial.features && (
                  <div className="service-features-wrapper">
                    <div className="features-title">Experience Includes:</div>
                    <div className="service-features-list">
                      {facial.features.map((feature, idx) => (
                        <div key={idx} className="feature-item">
                          <span className="feature-icon">✦</span>
                          <span className="feature-text">{feature}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                <button
                  className="service-book-btn"
                  onClick={() => handleBookService(facial.name, "facial")}
                >
                  Book This Treatment
                </button>
              </div>
            ))}
          </div>

          <div className="perks-box">
            <div className="perks-content">
              <h3>Complimentary Facial Perks</h3>
              <p className="perks-subtitle">Included with every Luxe Facial</p>
              <div className="perks-grid">
                {facialPerks.map((perk, index) => (
                  <div key={index} className="perk-item">
                    <span className="perk-icon">◆</span>
                    <span>{perk}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="services-section massages-section">
        <div className="section-content">
          <div className="services-header">
            <span className="section-label">Restorative Therapies</span>
            <h2>Customized Luxe Massages</h2>
            <p className="duration-note">60 or 120 minutes</p>
          </div>

          <div className="services-list">
            {massages.map((massage, index) => (
              <div key={index} className="service-item">
                <div className="service-top">
                  <div className="service-title-row">
                    <h3>{massage.name}</h3>
                    <span className="service-price">{massage.price}</span>
                  </div>
                  <p className="service-description">{massage.description}</p>
                </div>
                <button
                  className="service-book-btn"
                  onClick={() => handleBookService(massage.name, "massage")}
                >
                  Book This Treatment
                </button>
              </div>
            ))}
          </div>

          <div className="perks-box">
            <div className="perks-content">
              <h3>Complimentary Massage Perks</h3>
              <p className="perks-subtitle">Included with every Luxe Massage</p>
              <div className="perks-grid">
                {massagePerks.map((perk, index) => (
                  <div key={index} className="perk-item">
                    <span className="perk-icon">◆</span>
                    <span>{perk}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="deluxe-package-section">
        <div className="section-content">
          <div className="package-wrapper">
            <div className="package-badge">Signature Experience</div>
            <h2 className="package-title">{deluxePackage.name}</h2>
            <div className="package-pricing">
              <span className="package-price">{deluxePackage.price}</span>
              <span className="package-duration">{deluxePackage.duration}</span>
            </div>

            <div className="package-divider"></div>

            <p className="package-intro">{deluxePackage.description}</p>

            <div className="package-details">
              <div className="package-section">
                <h4>The Flow</h4>
                <p>{deluxePackage.flow}</p>
              </div>

              <div className="package-section">
                <h4>What's Included</h4>
                <div className="package-inclusions">
                  {deluxePackage.includes.map((item, index) => (
                    <div key={index} className="inclusion-item">
                      <span className="inclusion-check">✓</span>
                      <span>{item}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <button
              className="service-book-btn package-book-btn"
              onClick={() => handleBookService(deluxePackage.name, "package")}
            >
              Book This Package
            </button>
          </div>
        </div>
      </section>

      <section className="cta-section">
        <div className="cta-content">
          <h2>Begin Your Journey to Wellness</h2>
          <p>
            Reserve your personalized experience and discover the art of
            holistic beauty
          </p>
          <a href="/bookings" className="cta-button">
            Book Your Appointment
          </a>
        </div>
      </section>
    </div>
  );
};

export default Services;

